import { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getDepartement } from "./inc/departement";
import { getRegion } from "./inc/region";

const MapHeader = ({
  locationSearch,
  setLocationSearch,
  setFilterScreen,
  setShowFiltersFrom,
  filtersKeys,
  filtersState,
  userCurrentPosition,
  setUserCurrentPosition,
  setGeoSearch,
  geoSearch,
  mapScreen,
  setSelectedGeoAdress,
  isFocused,
  setIsFocused,
  townDefaultValue
}) => {
  const { t, i18n } = useTranslation();

  const inputSearchRef = useRef(null);
  useEffect(() => {
    // If searchCity is 2 letters or more

    if (locationSearch?.length > 0) {
      let results = [];
      if (locationSearch.length > 2) {
        const searchParam = locationSearch.replace(" ", "+");
        fetch(
          `https://api-adresse.data.gouv.fr/search/?q=${searchParam}&limit=5`
        )
          .then((res) => res.json())
          .then((data) => {
            results = [
              ...data.features,
            ];

            setGeoSearch(results);
          })
          .catch((errors) => console.log(errors));
      } else {
        results = [
        ];
        setGeoSearch(results);
      }
    } else {
      setGeoSearch(null);
    }
  }, [locationSearch]);

  useEffect(() => {
    if (userCurrentPosition) {
      fetch(
        `https://api-adresse.data.gouv.fr/reverse/?lon=${userCurrentPosition.longitude}&lat=${userCurrentPosition.latitude}&type=street`
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.features[0]) {
            setSelectedGeoAdress(data.features[0]);
            resetInput()
            inputSearchRef.current.value = data.features[0].properties.label;
          } else {
            setSelectedGeoAdress({
              geometry: {
                coordinates: [
                  userCurrentPosition.longitude,
                  userCurrentPosition.latitude,
                ],
              },
              properties: {
                id: "not_found",
                label: "Pas dadresse associée",
                type: "street",
              },
            });
          }
        });
    }
  }, [userCurrentPosition]);

  // useEffect(() => {
  //   if (inputSearchRef.current) {
  //     inputSearchRef.current.focus();
  //     setIsFocused(true);
  //   }
  // }, []);

  useEffect(() => {
    inputSearchRef.current.value = townDefaultValue
  }, [townDefaultValue]);

  let typingTimer; //timer identifier
  const doneTypingInterval = 500; //time in ms, 5 second for example
  const handleType = (value) => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setLocationSearch(value);
    }, doneTypingInterval);
  };

  //--- Show filter screen on mobile
  const handleFilterScreen = () => {
    document.body.classList.add("no-scroll");
    setFilterScreen(true);
    setShowFiltersFrom("from-list");
  };

  //count active filters
  let activeFilterCount = 0;
  filtersKeys.forEach((key) => {
    if (filtersState[key]?.length) {
      activeFilterCount += filtersState[key]?.length;
    }
  });

  const emptySearchbar = () => {
    inputSearchRef.current.value = "";
    resetInput()
    setSelectedGeoAdress(null);
  };

  const handleGeolocalisation = () => {
    let geo = {};
    // let currentPositionLatitude = '';

    function success(pos) {
      const crd = pos.coords;
      // console.log(pos);
      setUserCurrentPosition({
        latitude: crd.latitude,
        longitude: crd.longitude,
      });
    }

    if (navigator.geolocation) {
      geo = navigator.geolocation;
      geo.getCurrentPosition(success);
    }
  };
  const resetInput = () => {
    inputSearchRef.current.value = ""
    setLocationSearch("")
  }

  const handleGeoAdress = (address) => {
    setSelectedGeoAdress(address);
    inputSearchRef.current.value = address.properties.label;
    setIsFocused(false)
    setGeoSearch(null);
  };
  const refDivGeo = useRef(null)

  const checkGeoSearchResult = ({ label, postcode }) =>
    label.includes(postcode) ? label : `${postcode} ${label}`;

  return (
    <div className={`map-header ${mapScreen === false ? "mobile-map-header-up" : ""}`}>
      {isFocused && <div className={`geosearch-results-wrapper ${mapScreen === false ? "mobile-geosearch-results-wrapper-down" : ""}`} onClick={() => setIsFocused(false)}></div>}
      <div className="search-input__wrapper">
        <span className="iconReactLeafletsearch"></span>
        <input
          placeholder="Ville, code postal, département, région"
          className="search-input"
          type="text"
          onChange={(e) => handleType(e.target.value)}
          onFocus={() => setIsFocused(true)}
          ref={inputSearchRef}
        />
        {locationSearch && (
          <span onClick={resetInput} className="icon iconReactLeafletx"></span>
        )}
        {isFocused && geoSearch?.length > 0 && (
          <div className="geosearch-results geosearch-results-active" ref={refDivGeo}>
            <ul>
              {geoSearch.map((address) => (
                <li
                  key={address.properties.id}
                  className={`result-item ${address.properties.type}`}
                  onClick={() => handleGeoAdress(address)}
                >
                  <span>{checkGeoSearchResult(address.properties)}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>


      <div className="geolocalisation-wrapper">
        <button
          type="button"
          className="geolocalisation-btn"
          onClick={handleGeolocalisation}
        >
          <span className="icon iconReactLeafletmarker"></span> Me localiser
        </button>
        {/* <button
          className={`sidebar__btn-filtres ${process.env.REACT_APP_FILTERS === "modal" ? "show" : ""
            }`}
          onClick={handleFilterScreen}
        >
          <span className="icon iconReactLeafletfilter"></span>
          {t("filters")}
          {activeFilterCount !== 0 && (
            <span className="count">{activeFilterCount}</span>
          )}
        </button> */}
      </div>
    </div>
  );
};

export default MapHeader;
